export default "__VITE_ASSET__346d1d30__"